import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PRIVACY_HIDE_RECRUITER = createFcmDetails('privacy_hide_recruiter', {
	owner: 'Site Platform',
	context: 'Petition page',
	description: `
			Indicates whether to hide the recruiter name on the petition page, based on the recruiter's country. Personalized links for facebook will not be created.
			Bandatized links will not be created.

			Locale configs will be ignored.

			Related to petition_display_recruiter_name (which conditions the feature itself).
		`,
	import: false,
});
